__turbopack_context__.v({
  "backdrop": "JZVeKW_backdrop",
  "closeButton": "JZVeKW_closeButton",
  "image": "JZVeKW_image",
});
